import * as prometheus from '../tracking/prometheus';

export function addClickEventsPrometheus(container: HTMLElement) {
    const items = container.querySelectorAll('[data-finn-adid]');
    [].forEach.call(items, (div: HTMLDivElement) => {
        div.addEventListener('click', prometheus.logClick);
    });
}
